import { accountDetails } from "@di";
import { downloadReportsRepo } from "@frameworks/web/components/Reports/understandingCommonDI/downloadReportsDI";
import SubscriptionReport from "@adapters/repositories/Reports/SubscriptionReport";
export default (http) => {
    return {
        subscriptionReport: new SubscriptionReport(http, accountDetails),
        downloadRepo: downloadReportsRepo,
    };
};
